import { createSlice } from "@reduxjs/toolkit";

const initialProductCategoryState = {
  listLoading: false,
  actionsLoading: false,
  lastError: null,
  productCategorys: [],
  countProductCategorys: 0
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const productCategorySlice = createSlice({
  name: 'productCategory',
  initialState: initialProductCategoryState,
  reducers: {
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    productCategorysFetched: (state, action) => {
      const {data} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.productCategorys = data.data ? data.data : [];
      state.countProductCategorys = data.count ? data.count : 0
    },

    catchError: (state, action) => {
      state.lastError = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    endCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.action) {
        state.actionsLoading = false;
      } else {
        state.importLoading = false;
      }
    },
  },
});
